module.exports = __webpack_public_path__ + "img/taux_eleve_en_proteines.d916180.svg";